export default __webpack_public_path__ + "static/media/carousel-img-7.1f54e3d8.webp";